import produce from 'immer';
import { UserCreationState, UserState } from './user-state-models';
import * as UserActions from './user.actions';
import { UserActionTypes } from './user.actions';

export const initialUserCreationState: UserCreationState = {
  registrationRequest: null,
  registrationResponse: null,
  currentUser: null,
  loading: false,
  error: null,
  registrationFailedErrorType: null,
};

export const initialState: UserState = {
  loading: false,
  userIsFetched: false,
  user: {
    firstName: null,
    lastName: null,
    email: null,
    phoneNumber: null,
    phoneNumberValidated: false,
    newsletters: false,
    updates: false,
    contactMethod: null,
    activeConsultantProwessId: null,
    smsTransactionalConsent: false,
    smsPromotionalConsent: false,
  },
  registrationFailedErrorType: null,
  userCreation: initialUserCreationState,
};

export const reducer = produce((draft, action) => {
  switch (action.type) {
    case UserActionTypes.resetUserStore:
      return initialState;

    case UserActionTypes.fetchUser:
    case UserActionTypes.registerUser:
      draft.loading = true;
      return draft;

    case UserActionTypes.fetchUserSuccess:
      draft.loading = false;
      draft.userIsFetched = true;
      draft.user = {
        ...draft.user,
        ...action.user,
        phoneNumber: action.user.phoneNumber.slice(-10),
      };
      return draft;

    case UserActionTypes.updateUser:
      draft.loading = true;
      draft.userIsFetched = true;
      const phoneNumberValidated =
        draft.user.phoneNumberValidated && draft.user.phoneNumber === action.user.phoneNumber;
      draft.user = {
        ...draft.user,
        ...action.user,
        phoneNumberValidated,
      };
      return draft;

    case UserActionTypes.updateUserSuccess:
      draft.loading = false;
      draft.user = {
        ...draft.user,
        ...action.user,
        phoneNumber: action.user.phoneNumber.slice(-10),
      };
      return draft;

    case UserActionTypes.fetchUserWithConsultant:
      draft.loading = true;
      return draft;

    case UserActionTypes.fetchUserWithConsultantSuccess:
      draft.loading = false;
      draft.user = { ...draft.user, ...action.user };
      return draft;

    case UserActionTypes.updateUserFailure:
    case UserActionTypes.fetchUserFailure:
    case UserActionTypes.fetchUserWithConsultantFailure:
    case UserActionTypes.registerUserSuccess:
      draft.loading = false;
      return draft;

    case UserActionTypes.registerUserFailure:
      draft.loading = false;
      draft.registrationFailedErrorType = action.error.ErrorType;
      return draft;

    case UserActionTypes.resetRegistrationFailedErrorType:
      draft.registrationFailedErrorType = initialState.registrationFailedErrorType;
      return;

    case UserActionTypes.signUpPhoneUser:
      draft.loading = true;
      draft.userCreation.error = null;
      draft.userCreation.registrationFailedErrorType = null;
      break;

    case UserActionTypes.signUpPhoneUserSuccess: {
      const successAction = action as ReturnType<typeof UserActions.sigunpPhoneUserSuccess>;
      draft.loading = false;
      draft.userCreation.registrationRequest = successAction.request;
      draft.userCreation.registrationResponse = successAction.response;
      draft.userCreation.currentUser = successAction.response;
      draft.userCreation.error = null;
      draft.userCreation.registrationFailedErrorType = null;
      break;
    }

    case UserActionTypes.signUpPhoneUserFailure: {
      const failureAction = action as ReturnType<typeof UserActions.sigunpPhoneUserFailure>;
      draft.loading = false;
      draft.userCreation.error = failureAction.error.ErrorMessage || 'Registration failed';
      draft.userCreation.registrationFailedErrorType = failureAction.error || null;
      break;
    }

    case UserActionTypes.resetRegistrationFailedErrorType:
      draft.userCreation.registrationFailedErrorType = null;
      draft.userCreation.error = null;
      draft.registrationFailedErrorType = null;
      break;

    default:
      return draft;
  }
}, initialState);
